import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, Slide } from 'react-toastify';
import RoutesConfig from './routes/RoutesConfig';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
// import TopAlerts from './components/common/TopAlerts';
import setupAxiosInterceptors from './utils/axiosInterceptor';
// import activityLogger from './utils/activityLogger';

const scripts = [
  // '/assets/vendors/feather-icons/feather.min.js',
  // '/assets/js/phoenix.js', // Loaded globally in index.html
];

function AppContent() {
  const location = useLocation();

useEffect(() => {
  // console.log('[Debug] Initializing Phoenix after route change...');

  if (window.feather) {
    // console.log('[Debug] Feather icons found, replacing...');
    window.feather.replace({
      width: "16px",
      height: "16px"
    });
  }
}, [location]);

  return (
    <>
      <RoutesConfig />
      {/* <TopAlerts /> */}
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeButton={false}
        pauseOnFocusLoss={false}
        pauseOnHover
        draggable
        theme="colored"
        transition={Slide}
        style={{ top: '80px' }}
      />
    </>
  );
}

function App() {
  // Initialize Axios interceptors to add user ID to all API requests
  useEffect(() => {
    setupAxiosInterceptors();
  }, []);

  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <AppContent />
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
